import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Grid } from "@material-ui/core";
import { WizardStepper } from "./WizardStepper";
import { FormErrors } from "../../../components/FormErrors";
import { ThemeProvider } from "@material-ui/core/styles";
import { useStyles, actionsTheme } from "./styles";
import { Panel } from "../../../panel";
import FormStatus from "../../../components/FormStatus";
const panelSettings = {
    main: {},
    summary: {
        defaultOptions: {
            literal: true
        }
    },
    actions: {},
    appActions: {}
};
addRegisteredLayout({
    name: "WizardSummary",
    displayName: "WizardSummary",
    panels: panelSettings
});
export function WizardSummary(props) {
    const classes = useStyles(props);
    const { header, panels, stepper } = props;
    const { main, summary, actions, appActions } = panels;
    return (_jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, container: true, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 8, md: 4, children: header }), _jsx(Grid, { item: true, xs: 4, container: true, alignItems: "stretch", justifyContent: "flex-end", children: _jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...appActions, justifyContent: "flex-end", disableExpansion: true, transparent: true, disableTabs: true }) }) })] }) }), _jsx(Grid, { item: true, xs: 12, md: 8, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsxs(Grid, { item: true, xs: 12, children: [!stepper && _jsx(WizardStepper, {}), _jsx(FormStatus, { className: classes.errorSection }), _jsx(FormErrors, { className: classes.errorSection })] }), _jsx(Grid, { item: true, xs: 12, children: summary && _jsx(Panel, { ...summary }) }), _jsx(Grid, { item: true, xs: 12, children: main && _jsx(Panel, { ...main }) }), _jsx(Grid, { item: true, xs: 12, children: actions && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { justifyContent: "flex-end", disableExpansion: true, transparent: true, disableTabs: true, ...actions }) })) })] }) })] }));
}
//# sourceMappingURL=WizardSummary.js.map